/*eslint-disable*/
import api from '../'

class StatisticsApi {
    static list(params, cancelToken = null) {
        return api.axios.get('/billing-statistics', {params, cancelToken})
            .then(response => response.data);
    }
}

export default StatisticsApi;
